export default __webpack_public_path__ + "722850040743f3ad4c21c15e8e019305.png";